import gsap, { SplitText } from "@lib/gsap";
import { isStaging } from "@/webflow/is-staging";
import { onDestroy } from "./_";
import { scrollTriggerDefaults } from "@lib/animations";
import { Resize } from "@lib/subs";

export default function (element, dataset) {
  const selector = dataset.selector || ".u-heading-highlight h2";
  const heading = element.querySelector(selector);
  if (!heading) return;

  let split, tl;

  function create() {
    split = new SplitText(heading, {
      type: "chars, words, lines",
      charsClass: "char",
      linesClass: "u-text-trim-off",
      deepSlice: true,
    });

    const strongs = heading.querySelectorAll("strong");

    gsap.set(split.chars, { color: "#DCD5CC" });
    gsap.set(strongs, { "--highlight-scale": 0 });

    const charStagger = 0.4;
    const lineGap = 2;

    tl = gsap.timeline({
      scrollTrigger: {
        ...scrollTriggerDefaults,
        trigger: element,
        markers: isStaging,
      },
      defaults: { ease: "none" },
    });

    split.lines.forEach((line, index) => {
      const lineChars = line.querySelectorAll(".char");
      tl.to(lineChars, { color: "#000", stagger: charStagger }, lineGap * index);
    });
    tl.to(strongs, { "--highlight-scale": 1, stagger: 0.5, duration: 4 }, ">-=2");
  }

  function teardown() {
    tl?.kill();
    split?.revert();
  }

  create();

  const removeResize = Resize.add(() => {
    teardown();
    create();
  });

  onDestroy(() => {
    removeResize();
    teardown();
  });
}
